(function () {
  function addBusinessDays(date, days) {
    var result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var added = 0;

    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        added += 1;
      }
    }

    return result;
  }

  function renderDeliveryEstimates() {
    var language = document.documentElement.lang || 'fr';
    var formatter = new Intl.DateTimeFormat(language, {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });
    var now = new Date();

    document.querySelectorAll('[data-sc-delivery-estimate]').forEach(function (element) {
      var minDays = Number(element.getAttribute('data-min-days')) || 5;
      var maxDays = Number(element.getAttribute('data-max-days')) || 8;
      var fromDate = formatter.format(addBusinessDays(now, minDays));
      var toDate = formatter.format(addBusinessDays(now, maxDays));
      var isFrench = language.toLowerCase().indexOf('fr') === 0;

      element.textContent = isFrench ?
        'Livraison estimée entre le ' + fromDate + ' et le ' + toDate + '.' :
        'Estimated delivery between ' + fromDate + ' and ' + toDate + '.';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderDeliveryEstimates);
  } else {
    renderDeliveryEstimates();
  }
}());
